import { v4 as uuidv4 } from "uuid";
import { IBaoCaoTab } from "../../../model/respone/bao-cao/IBaoCaoTab";
import { IBaoCaoActionTypes } from "../../action-types/bao-cao/IBaoCaoActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IBaoCaoReducer } from "./../../reducer-model/bao-cao/IBaoCaoReducer";
import { IBaoCaoRequest } from "../../../model/request/bao-cao/IBaoCaoRequest";
const initTab: IBaoCaoTab = {
  id: uuidv4(),
  status: eReducerStatusBase.is_not_initialization,
  title: "Untitled",
  isShowFilter: true,
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_bao_cao: 0,
    id_hes: [],
    id_khoas: [],
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
  } as IBaoCaoRequest,
  result: "",
} as IBaoCaoTab;

const iniState: IBaoCaoReducer = {
  tabs: [initTab],
  selectedId: initTab.id,
};
export const baoCaoReducer = (
  state: IBaoCaoReducer = iniState,
  action: IBaoCaoActionTypes
): IBaoCaoReducer => {
  switch (action.type) {
    case "BAO_CAO_LOAD_START":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_loading,
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_LOAD_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
              result: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_LOAD_ERRR":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
              result: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_CHANGE_REQUEST":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_need_reload,
              request: {
                ...g.request,
                ...action.payload.data,
              },
              result: "",
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_ADD_NEW_TAB":
      const id = uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: [
          {
            title: "Untitled",
            id: id,
            request: {
              hoc_ky: 0,
              nam_hoc: "",
              id_bao_cao: 0,
              id_hes: [],
              id_khoas: [],
              id_lops: [],
              id_nganhs: [],
              id_thu_chis: [],
              khoa_hocs: [],
            } as IBaoCaoRequest,
            result: "",
            status: eReducerStatusBase.is_not_initialization,
          } as IBaoCaoTab,
          ...state.tabs,
        ],
      };
    case "BAO_CAO_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "BAO_CAO_CHANGE_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "BAO_CAO_CHANGE_TITLE_TAB":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              title: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_EXPORT_BAO_CAO_START":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? { ...g, status: eReducerStatusBase.is_loading }
            : g
        ),
      };

    case "BAO_CAO_EXPORT_BAO_CAO_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? { ...g, status: eReducerStatusBase.is_completed }
            : g
        ),
      };

    case "BAO_CAO_EXPORT_BAO_CAO_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? {
                ...g,
                status: eReducerStatusBase.is_completed,
                result: action.payload.data,
              }
            : g
        ),
      };

    case "BAO_CAO_SHOW_HIDE_FILTER":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? {
                ...g,
                isShowFilter: action.payload.data,
              }
            : g
        ),
      };

    default:
      return state;
  }
};
